module.exports = __webpack_public_path__ + "img/compas-2.44776b74.svg";